<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="$t.__('documents.overview.tab.margin.LinkCustomEntryForm.add_profit_entry')"
        :closeOnClickOverlay="false"
        @closed="$emit('close')"
    >
        <template #default>
            <div class="dialog__default">
                <el-form ref="linkCustomEntryForm" labelPosition="top">
                    <el-form-item
                        :label="$t.__('documents.overview.tab.margin.descirption')"
                        prop="label"
                        :error="errors.get('label')"
                    >
                        <el-input v-model="label" name="label" maxlength="255" />
                    </el-form-item>

                    <el-form-item
                        :label="
                            $t.__(
                                'documents.overview.tab.margin.LinkCustomEntryForm.unit_amount_exclude_tax',
                            )
                        "
                        prop="amounttaxefree"
                        :error="errors.get('amounttaxefree')"
                    >
                        <input-number
                            v-model="amounttaxefree"
                            :precision="unitNumberFormat.precision"
                            :separatorDecimal="unitNumberFormat.decimal"
                            :separatorThousand="unitNumberFormat.thousand"
                            class="w-2"
                        >
                        </input-number>
                    </el-form-item>

                    <el-form-item
                        :label="$t.__('common.labels.quantity')"
                        prop="qt"
                        :error="errors.get('qt')"
                    >
                        <input-number
                            v-model="qt"
                            name="qt"
                            :min="0.01"
                            :controls="false"
                            :precision="numberFormat.precision"
                            :separatorDecimal="numberFormat.decimal"
                            :separatorThousand="numberFormat.thousand"
                            class="w-2"
                        />
                    </el-form-item>
                    <el-form-item
                        :label="
                            $t.__(
                                'documents.overview.tab.margin.LinkCustomEntryForm.total_exclude_tax',
                            )
                        "
                        prop="totalamount"
                        :error="errors.get('totalamount')"
                    >
                        {{ $filters.numberFormat(total) }}
                    </el-form-item>
                </el-form>
            </div>
        </template>
        <template #footer>
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="$emit('close')"
                />
                <CompassButton
                    v-if="customIsEmpty"
                    :label="$t.__('common.actions.save')"
                    type="primary"
                    :disabled="saveBtnIsdisabled"
                    class="ml-3"
                    @click="save()"
                />
                <CompassButton
                    v-else
                    :label="$t.__('documents.overview.tab.margin.LinkCustomEntryForm.update')"
                    type="primary"
                    :disabled="saveBtnIsdisabled"
                    class="ml-3"
                    @click="edit()"
                />
            </div>
        </template>
    </CompassDialog>
</template>

<script>
import InputNumber from 'vcomponents/utilities/InputNumber.vue';
import AmountMaskedInput from 'vcomponents/inputs/AmountMaskedInput.vue';
import FormMixins from 'vcomponents/../mixins/FormMixins';
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('documentOverview');

export default {
    components: {
        'input-number': InputNumber,
        AmountMaskedInput,
    },
    mixins: [FormMixins],
    props: {
        custom: {
            required: false,
            type: Object,
            validator: function (value) {
                if (Object.keys(value).length === 0 && value.constructor === Object) {
                    return true;
                }

                if (!value.hasOwnProperty('label')) {
                    return false;
                }
                if (!value.hasOwnProperty('qt')) {
                    return false;
                }
                if (!value.hasOwnProperty('unitAmount')) {
                    return false;
                }
                if (!value.hasOwnProperty('customId')) {
                    return false;
                }
                if (!value.hasOwnProperty('linkedId')) {
                    return false;
                }
                return true;
            },
        },
    },
    data() {
        return {
            showModal: true,
            saveBtnIsdisabled: false,
            label: '',
            qt: 1,
            amounttaxefree: 0,

            numberFormat: {
                precision: this.getPrecision(),
                decimal: App.numformat.decimals,
                thousand: App.numformat.thousands,
            },
            unitNumberFormat: {
                precision: this.getUnitAmountPrecision(),
                decimal: App.numformat.decimals,
                thousand: App.numformat.thousands,
            },
        };
    },
    computed: {
        customIsEmpty() {
            return Object.keys(this.custom).length === 0 && this.custom.constructor === Object;
        },
        total() {
            return this.amounttaxefree * this.qt;
        },
    },
    created() {
        if (this.customIsEmpty) {
            return;
        }

        this.qt = this.custom.qt;
        this.amounttaxefree = this.custom.unitAmount;
        this.label = this.custom.label;
    },
    methods: {
        getPrecision() {
            return parseInt(App.numformat.precision);
        },
        getUnitAmountPrecision() {
            if (App.numformat.precisioncustom && App.numformat.precisioncustom.unitAmount) {
                var precision = parseInt(App.numformat.precisioncustom.unitAmount);
                if (!isNaN(precision)) {
                    return precision;
                }
            }
            return this.getPrecision();
        },
        customEntry() {
            let entry = {
                label: this.label,
                amounttaxefree: this.amounttaxefree,
                qt: this.qt,
                totalamount: this.total,
            };

            if (!this.customIsEmpty) {
                entry.customId = this.custom.customId;
                entry.linkedId = this.custom.linkedId;
            }

            return entry;
        },
        save() {
            this.saveBtnIsdisabled = true;
            this.addCustomLink(this.customEntry()).then(
                (response) => {
                    Push.info(this.$l10n.__('Marge en cours de calcul'));
                    this.$emit('close');
                    this.$emit('custom-entry-added');
                },
                (error) => {
                    this.errors.setErrors(error.response.data.error.message);
                    this.saveBtnIsdisabled = false;
                },
            );
        },
        edit() {
            this.saveBtnIsdisabled = true;
            this.updateCustomLink(this.customEntry()).then(
                (response) => {
                    Push.info(this.$l10n.__('Marge en cours de calcul'));
                    this.$emit('close');
                    this.$emit('custom-entry-added');
                },
                (error) => {
                    this.errors.setErrors(error.response.data.error.message);
                    this.saveBtnIsdisabled = false;
                },
            );
        },
        ...mapActions(['addCustomLink', 'updateCustomLink']),
    },
};
</script>

<style lang="scss">
.link-custom-entry-form {
    .dialog {
        &__default {
            padding-bottom: 24px;
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }
}
</style>
